<template>
  <div>
    <ReviewFormPage
      v-if="!isReviewSubmitted"
      :selectedRating="selectedRating"
      @submit="handleSubmit"
      @close="$emit('close')"
    />

    <ThankYouPage
      v-else
      :review="submittedReviewData"
      @close="handleCloseReview"
    />
  </div>
</template>

<script>
  import ReviewFormPage from "./ReviewFormPage.vue"
  import ThankYouPage from "./ThankYouPage.vue"

  export default {
    name: "AddEditReview",
    components: {
      ReviewFormPage,
      ThankYouPage,
    },
    inject: ["resetAndInitializeApi"],
    props: {
      selectedRating: {
        type: [Number, String],
        default: 0,
      },
    },
    data() {
      return {
        isReviewSubmitted: false,
        submittedReviewData: null,
      }
    },
    methods: {
      handleSubmit(reviewData) {
        if (reviewData.type === "add_review") {
          this.submittedReviewData = reviewData
          this.isReviewSubmitted = true
        } else {
          this.handleCloseReview()
        }
      },
      handleCloseReview() {
        this.resetAndInitializeApi("reset_state")
        this.$emit("close")
      },
    },
  }
</script>
